import type { WheelEvent } from 'react';
import { APP_SCROLL_CLASS, APP_SCROLL_MEDIA_QUERY } from './constants';

export const appScrollMedia = window.matchMedia(APP_SCROLL_MEDIA_QUERY);

export const getAppScrollElement = () =>
  appScrollMedia.matches ? document.querySelector<HTMLElement>(`.${APP_SCROLL_CLASS}`) : null;

export const getAppScrollTop = () => getAppScrollElement()?.scrollTop ?? window.scrollY;

export const appScrollTo = (options: ScrollToOptions) =>
  (getAppScrollElement() ?? window).scrollTo(options);

const canScrollY = (element: HTMLElement, deltaY: number) => {
  if (!/(auto|scroll)/.test(getComputedStyle(element).overflowY)) return false;
  const { scrollTop, scrollHeight, clientHeight } = element;
  return deltaY < 0 ? scrollTop > 0 : scrollTop + clientHeight < scrollHeight - 1;
};

export const forwardWheelToAppScroll = (event: WheelEvent<HTMLElement>) => {
  const scrollElement = getAppScrollElement();
  if (!scrollElement || !event.deltaY) return;

  let node = event.target as HTMLElement | null;
  while (node && node !== event.currentTarget) {
    if (canScrollY(node, event.deltaY)) return;
    node = node.parentElement;
  }

  const lineHeight = 16;
  const top = event.deltaMode === 1 ? event.deltaY * lineHeight : event.deltaY;
  scrollElement.scrollBy({ top });
};
